/**
 * Load Third Party Scripts dynamically
 */
export default class ThirdPartyScriptsChunk {
  static body: HTMLElement;

  static link: HTMLElement;

  constructor() {
    ThirdPartyScriptsChunk.body = document.querySelector('body');

    const isProductPage =
      ThirdPartyScriptsChunk.body.classList.contains('l-product');
    const isNewCheckout = !!document.querySelector('.l-checkout');

    setTimeout(() => {
      if (
        !ThirdPartyScriptsChunk.body.classList.contains('mobile') &&
        !isProductPage &&
        !isNewCheckout
      ) {
        import(
          /* webpackPreload: true */ /* webpackChunkName: 'preload-google-badge' */ '../../../../../../assets/js/modules/tihrd-party-scripts/google-badge'
        ).then(({ default: googleBadge }) => {
          // eslint-disable-next-line new-cap
          new googleBadge();
        });
      }
    }, 5000);
  }
}
